// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__qPZc-","rightAdornment":"Header_rightAdornment__gYjCl"};